export { AKAMAI_HEADER_SECRET_ARN, getHeaderAkamai } from './header_mango'
